import React from 'react';
import {BrowserRouter as Router,Routes,Route} from 'react-router-dom';
import {CMSProvider} from './context/CMSContext';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import QuickContact from './components/layout/QuickContact';
import WhatsAppButton from './components/layout/WhatsAppButton';
import ScrollToTop from './components/layout/ScrollToTop';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import ServiceDetail from './pages/ServiceDetail';
import Contact from './pages/Contact';
import Legal from './pages/Legal';
import './index.css';

function App() {
  return (
    <CMSProvider>
      <Router>
        <div className="min-h-screen bg-gray-50">
          <Header />
          <main className="pt-24 lg:pt-32">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/services/:serviceId" element={<ServiceDetail />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/legal" element={<Legal />} />
            </Routes>
          </main>
          <Footer />
          <QuickContact />
          <WhatsAppButton />
          <ScrollToTop />
        </div>
      </Router>
    </CMSProvider>
  );
}

export default App;